import { Injectable } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  entity!: FormGroup
  formMethod = 'CREATE'
  permissions: {label: string; value: string;}[] = [
    { label: "Selecciona una opción", value: "" }
  ]
  constructor(
    private fb: FormBuilder
  ) { }

  newEntity() {
    switch (this.formMethod) {
      case 'CREATE':
        this.entity = this.fb.group({
          name: ['', [Validators.required]],
          permission: ['', [Validators.required]],
          description: ['', [Validators.required]]
        })
        break;
    }
  }

  getPermissionName(id: string) {
    return this.permissions.find(c => c.value === id)?.label
  }
}
